import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { JobPointeService } from 'src/app/service/job-pointe/job-pointe.service';

@Injectable({
  providedIn: 'root',
})
export class JobBoardService {
  constructor(private jobPointeService: JobPointeService) { }

  public updateJobBoard: Function;
  public employeeSideBarOpen: BehaviorSubject<any> = new BehaviorSubject(null);
  public employeeSideBarOpenSource: Observable<any> = this.employeeSideBarOpen.asObservable();
  public jobSideBarOpen: BehaviorSubject<any> = new BehaviorSubject(null);
  public jobSideBarOpenSource: Observable<any> = this.jobSideBarOpen.asObservable();
  public jobBoardLocked: BehaviorSubject<any> = new BehaviorSubject(false);
  public jobBoardLockedSource: Observable<any> = this.jobBoardLocked.asObservable();
  public jobBoardDialogAction: BehaviorSubject<any> = new BehaviorSubject(false);
  public jobBoardDialogActionSource: Observable<any> = this.jobBoardDialogAction.asObservable();
  public employeeCardSelected: BehaviorSubject<any> = new BehaviorSubject(false);
  public employeeCardSelectedSource: Observable<any> = this.employeeCardSelected.asObservable();
  public selectedEmployeeCards: BehaviorSubject<any> = new BehaviorSubject(false);
  public selectedEmployeeCardsSource: Observable<any> = this.selectedEmployeeCards.asObservable();
  public facilityJobAssignmentSelected: BehaviorSubject<any> = new BehaviorSubject(false);
  public facilityJobAssignmentSelectedSource: Observable<any> = this.facilityJobAssignmentSelected.asObservable();
  public formatShapeSelected: BehaviorSubject<any> = new BehaviorSubject(null);
  public formatShapeSelectedSource: Observable<any> = this.formatShapeSelected.asObservable();

  async removeEmployeeSchedule(scheduleData: any) {
    return this.jobPointeService.delete['employeeSchedule'](scheduleData).toPromise();
  }

  async toggleJobBoardLock() {
    return this.jobPointeService.update['jobBoardLock']({}).toPromise();
  }

  updateLocalBoardFilterState(state: any) {
    localStorage.setItem('jobBoardFilterState', JSON.stringify(state));
  }

  getLocalBoardFilterState() {
    return JSON.parse(localStorage.getItem('jobBoardFilterState'));
  }

  getLocalCardData() {
    return JSON.parse(localStorage.getItem('jobBoardCardData'));
  }

  updateLocalCardData(jobBoardCardData: any) {
    localStorage.setItem('jobBoardCardData', JSON.stringify(jobBoardCardData));
  }

  async getActiveEmployeesCount() {
    const params = {
      limit: 10000,
      'scope[hasEmployeeId]': true,
      'scope[isOnJobBoard]': 1,
      embed: 'jobBoardJobs'
    }
    await this.jobPointeService.read.employees(params).toPromise();
  }
}
